import { render, staticRenderFns } from "./MessageTempFile.vue?vue&type=template&id=7f2660a2&scoped=true&lang=pug"
import script from "./MessageTempFile.vue?vue&type=script&lang=ts"
export * from "./MessageTempFile.vue?vue&type=script&lang=ts"
import style0 from "./MessageTempFile.vue?vue&type=style&index=0&id=7f2660a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2660a2",
  null
  
)

export default component.exports